var transitionFadeInFromRight = function transitionFadeInFromRight(options) {
  var transitionDelay = options.transitionDelay,
    transitionDuration = options.transitionDuration,
    transitionStatus = options.transitionStatus;
  switch (transitionStatus) {
    case 'entered':
      {
        return {
          opacity: 1,
          right: 0
        };
      }
    case 'entering':
      {
        return {
          opacity: 1,
          right: 0,
          transition: "opacity ".concat(transitionDuration, "ms ease-in ").concat(transitionDelay, "ms, right ").concat(transitionDuration, "ms ease-in ").concat(transitionDelay, "ms")
        };
      }
    case 'exited':
      {
        return {
          opacity: 0,
          right: '-100%'
        };
      }
    case 'exiting':
      {
        return {
          opacity: 0,
          transition: "opacity ".concat(transitionDuration, "ms ease-in ").concat(transitionDelay, "ms, right ").concat(transitionDuration, "ms ease-in ").concat(transitionDelay, "ms"),
          right: '-100%'
        };
      }
    default:
      {
        // unmounted
        return {
          opacity: 0,
          right: '-100%'
        };
      }
  }
};
export { transitionFadeInFromRight };